<template>
  <Conversation
    :status-id="statusId"
    is-page
  />
</template>

<script src="./conversation-page.js"></script>
